import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ECommerceStoresSharedModule } from '@api-ui-app/src/app/e-commerce-stores/e-commerce-stores-shared.module';
import { DialogContainerComponent } from '@gelato-api-ui/sdk/src/lib/shared/dialog/dialog-container.component';
import { LokaliseModule } from '@gelato-api-ui/sdk/src/lib/shared/lokalise/lokalise.module';
import { TranslateModule } from '@ngx-translate/core';
import { ECommerceStoreListComponent } from './components/e-commerce-store-list/e-commerce-store-list.component';
import { ECommerceStoreSelectionModalComponent } from './components/e-commerce-store-selection-modal/e-commerce-store-selection-modal.component';
import { ECommerceStoreSelectionModalContainerComponent } from './containers/e-commerce-store-selection-modal-container/e-commerce-store-selection-modal-container.component';

@NgModule({
  declarations: [
    ECommerceStoreSelectionModalContainerComponent,
    ECommerceStoreSelectionModalComponent,
    ECommerceStoreListComponent,
  ],
  providers: [],
  imports: [CommonModule, DialogContainerComponent, TranslateModule, ECommerceStoresSharedModule, LokaliseModule],
})
export class ECommerceStoreSelectionModalModule {}
